// extracted by mini-css-extract-plugin
module.exports = {"signup":"Signup_signup__3q4PJ","login":"Signup_login__1wvpJ","google":"Signup_google__2Ui0c","divider":"Signup_divider__2ksCW"};